import React from 'react'

function Bio() {
  return (
    <div>Biology</div>
  )
}

export default Bio